export default function DefaultFooter() {
    return (
        <>
            <footer className="relative bg-gray-100 pt-8 pb-6">
                <div className="container max-w-7xl mx-auto px-4">
                    <div className="flex flex-wrap text-center lg:text-left pt-6">
                        <div className="w-full px-4">
                            <h5 className="text-2xl font-semibold text-gray-700">Rise Up Prison Ministry</h5>
                            <div className="-mt-4">
                                <p className="text-lg leading-relaxed mt-4 mb-4 text-gray-600">
                                    "But if you do not forgive others their sins, your Father will not forgive your sins" (Matthew 6:15).
                                </p>
                            </div>
                        </div>
                    </div>
                    <hr className="my-6 border-gray-300" />
                    <div className="flex flex-wrap items-center md:justify-between justify-center">
                        <div className="w-full px-4 mx-auto text-center">
                            <p className="text-sm text-gray-700 font-medium py-1">
                                Developed By Alex Wenner and Zach Khan
                            </p>
                            <p className="text-sm text-gray-700 font-medium py-1">
                                Website Consultations: alexwenner0@outlook.com and zachkhan99@gmail.com
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}
